export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.zastnow_vehicles) {
        return {...state, ...payload.zastnow_vehicles};
      }
      return state;
    }
  }
};
